import { DiscursiveAttemptsTable } from './DiscursiveAttemptsTable';
import { HttpError } from '@refinedev/core';
import { IAssessmentUser } from 'interfaces/assessments';
import {
  IStudentAttemptsFilter,
  StudentAttemptsFilter,
  toStudentAttemptsFilters
} from 'pages/evaluations/components/student-attempts-filter';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';

export const TabDiscursiveAttempts = () => {
  const params = useParams();
  const assessmentId = params.id;

  const { tableProps, searchFormProps } = useTable<
    IAssessmentUser,
    HttpError,
    IStudentAttemptsFilter
  >({
    resource: `assessments/${assessmentId}/users`,
    onSearch: toStudentAttemptsFilters
  });

  return (
    <>
      <StudentAttemptsFilter searchFormProps={searchFormProps} />

      <DiscursiveAttemptsTable tableProps={tableProps} />
    </>
  );
};
